import { Box, Flex, Paper, Text } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { get } from 'lodash';

import { NumberInput, Tooltip } from '@components';
import { EVALUATION_CALCULATOR_PERCENTAGE_FACTOR } from '@constants';
import { toDecimal } from '@utils';
import { renderActiveMethodButton } from './CustomerViewEvaluationMethods';
import classes from './CustomerViewEvaluationMethods.module.css';
import { CustomerViewEvaluationMethodsFormValues } from './useCustomerViewEvaluationMethodsFormInitializer';

interface CustomerViewEvaluationMethodInspectionProps {
  form: UseFormReturnType<CustomerViewEvaluationMethodsFormValues>;
}

export const CustomerViewEvaluationMethodInspection: React.FC<CustomerViewEvaluationMethodInspectionProps> = ({ form }) => {
  const { evaluationMethods } = form.values;

  const globalError = get(form.errors, 'evaluationMethods.evalMethodInspection.globalError');

  return (
    <Paper
      className={`${classes.evaluationMethodContainer} ${
        globalError ? classes.hasError : evaluationMethods.evalMethodInspection?.activateMethod || false ? classes.activeMethod : ''
      }`}
    >
      <Flex>
        <Box className={classes.evaluationMethodContainerHeaderBody}>
          <Text fz={14} mb={10}>
            EvalMethod Inspection
          </Text>
        </Box>
        {renderActiveMethodButton(
          form,
          evaluationMethods.evalMethodInspection?.activateMethod || false,
          'evaluationMethods.evalMethodInspection.activateMethod',
        )}
      </Flex>

      <Box className={classes.evaluationMethodFormRow} pt={25}>
        <NumberInput
          {...form.getInputProps('evaluationMethods.evalMethodInspection.periodOfInspection')}
          label="Period of Inspection"
          onChange={(value) => {
            form.setFieldValue('evaluationMethods.evalMethodInspection.periodOfInspection', Number(value));
          }}
          value={Number(evaluationMethods.evalMethodInspection?.periodOfInspection)}
        />
        <Tooltip content="Period of Inspection = Last x days" />
      </Box>

      <Box className={classes.evaluationMethodFormRow}>
        <NumberInput
          {...form.getInputProps('evaluationMethods.evalMethodInspection.inspectionRateOfVAT')}
          label="Inspection Rate of VAT ( % )"
          onChange={(value) => {
            form.setFieldValue('evaluationMethods.evalMethodInspection.inspectionRateOfVAT', Number(value) / EVALUATION_CALCULATOR_PERCENTAGE_FACTOR);
          }}
          value={toDecimal(Number(evaluationMethods.evalMethodInspection?.inspectionRateOfVAT) * EVALUATION_CALCULATOR_PERCENTAGE_FACTOR)}
        />
        <Tooltip content="Inspection Rate of VAT ( % )" />
      </Box>

      <Box className={classes.evaluationMethodFormRow} pb={30}>
        <NumberInput
          {...form.getInputProps('evaluationMethods.evalMethodInspection.inspectionRateOfEORI')}
          label="Inspection Rate of EORI ( % )"
          onChange={(value) => {
            form.setFieldValue('evaluationMethods.evalMethodInspection.inspectionRateOfEORI', Number(value) / EVALUATION_CALCULATOR_PERCENTAGE_FACTOR);
          }}
          value={toDecimal(Number(evaluationMethods.evalMethodInspection?.inspectionRateOfEORI) * EVALUATION_CALCULATOR_PERCENTAGE_FACTOR)}
        />
        <Tooltip content="Inspection Rate of EORI ( % )" />
      </Box>

      {!!globalError && <Box className={classes.error}>{globalError}</Box>}
    </Paper>
  );
};
